import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { BrandMark } from '../components/BrandMark';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useLocale } from '../contexts/LocaleContext';
import { homePath } from '../utils/clientReview';
export function PublishSuccess() {
  const {
    kind = 'post'
  } = useParams();
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const isPulse = kind === 'pulse';
  return <div className="px-2 pb-2 pt-4" data-id="element-3591" data-mp="1qalprfvas3gm">
      <Card tone="dark" className="rounded-panel p-3 text-center" data-id="element-3592" data-mp="1ld2bifylnqoo">
        <span className="mx-auto grid h-16 w-16 place-items-center rounded-pill border border-gold/50 bg-deeper" data-id="element-3593" data-mp="1ldc3g937g7x0">
          <BrandMark size={30} data-id="element-3594" data-mp="1gg3lo9lyy5wa" />
        </span>
        <p className="bee-overline mt-2 flex items-center justify-center gap-1 text-[9px] font-bold text-gold" data-id="element-3595" data-mp="3frd2ov2o2wxm">
          <CheckIcon size={12} strokeWidth={3} aria-hidden="true" data-id="element-3596" data-mp="3at1o671ffy92" />
          {isPulse ? t('success.pulse.tag') : t('success.post.tag')}
        </p>
        <h1 className="mt-1 text-title text-sand" data-id="element-3597" data-mp="39oy1hbfsir7y">
          {isPulse ? t('success.pulse.title') : t('success.post.title')}
        </h1>
        <p className="mx-auto mt-1 max-w-[30ch] text-[13px] leading-relaxed text-ondark" data-id="element-3598" data-mp="2zp785d2yui9g">
          {isPulse ? t('success.pulse.body') : t('success.post.body')}
        </p>
      </Card>

      <Button variant="gold" size="lg" fullWidth className="mt-3" onClick={() => navigate('/feed')} data-id="element-3599" data-mp="3scjimovuqzme">
        {t('success.seeFeed')}
      </Button>
      <Button variant="outline" size="lg" fullWidth className="mt-2" onClick={() => navigate(homePath())} data-id="element-3600" data-mp="3injekr2hte1c">
        {t('success.backHome')}
      </Button>
    </div>;
}